import Transformer from '@/transformers/transformer'

export default class supplyConfigTransformer extends Transformer {
  static fetch({
    added_date: addedDate, /*average_cp: averageCp,*/current_stock: currentStock,
    days_of_freight: freightDays, days_to_pay: daysToPay, factory_set: inFactory,
    id, it_is_active: isActive, iwarehouse: currentWarehouseId, last_update: lastUpdate,
    /*max_cmx: cmx,*/ max_existence: maxStock, /*min_cmn: minCmn,*/ min_existence: minStock,
    reorder_point: reorderPoint, repositioning_time: replacementTime,
    suggested_in_warehouse: warehouseSuggested, supply_data: supplyData, unit_cost: unitaryCost,
    value_max_existence: maxStockValue, value_min_existence: minStockValue,
    value_reorder_point: reorderPointValue, value_suggested_in_warehouse: warehouseSuggestedValue,
    physical_stock: physicalStock, assigned_stock: assignedStock
  }) {
    return {
      addedDate,
      // averageCp,
      currentStock,
      physicalStock: +physicalStock,
      freightDays,
      daysToPay,
      inFactory,
      id,
      isActive,
      currentWarehouseId,
      lastUpdate,
      // cmx,
      maxStock,
      // minCmn,
      minStock,
      reorderPoint,
      replacementTime,
      warehouseSuggested,
      supply: supplyData,
      supplyId: supplyData.id,
      supplyName: supplyData.name,
      supplyUnit: supplyData.unit,
      supplyCode: supplyData.code,
      unitaryCost,
      maxStockValue,
      minStockValue,
      reorderPointValue,
      warehouseSuggestedValue,
      // CAMPO PARA QUE EL USUARIO PUEDA PONER LA CANTIDAD DE SALIDA (ESTO NO VA AQUI, VA EN EL NUEVO ENDPOINT):
      adjustmentOutput: 0,
      assignedStock: +assignedStock
    }
  }

  static send({
    supply, unitaryCost: unit_cost, minStock: min_existence, maxStock: max_existence,
    reorderPoint: reorder_point, warehouseSuggested: suggested_in_warehouse,
    minStockValue: value_min_existence, maxStockValue: value_max_existence,
    reorderPointValue: value_reorder_point, warehouseSuggestedValue: value_suggested_in_warehouse,
    inFactory: factory_set, daysToPay: days_to_pay, freightDays: days_of_freight,
    replacementTime: repositioning_time, /*minCmn: min_cmn, averageCp: average_cp,
    cmx: max_cmx, currentStock: current_stock,*/ currentWarehouseId: iwarehouse,
    currentUserId
  }) {
    return {
      supply,
      unit_cost,
      min_existence,
      max_existence,
      reorder_point,
      suggested_in_warehouse,
      value_min_existence,
      value_max_existence,
      value_reorder_point,
      value_suggested_in_warehouse,
      factory_set,
      days_to_pay,
      days_of_freight,
      repositioning_time,
      // min_cmn,
      // average_cp,
      // max_cmx,
      // current_stock,
      iwarehouse,
      added_by: currentUserId,
      last_updated_by: currentUserId
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/supplyConfig.js